<zef-dialog
  [open]="state.open"
  [autoFocus]="false"
  (closeTrigger)="onClose$.next()">
  <div *ngIf="state.data as data" class="__content">

    <h3 class="__title">{{ state.translations.entityDeleted }}</h3>

    <p
      class="__desc"
      [innerHTML]="state.translations.desc | safeHtml">
    </p>

    <a
      mat-stroked-button
      type="button"
      [routerLink]="!!state.data?.meta?.routerLink?.length ? state.data.meta.routerLink : [ '/' ]"
      (click)="onClose$.next()"
      class="__button [ c-button--full  c-button--larger c-button--routing ]">

      {{ !!state.data?.meta?.buttonText ? state.data.meta.buttonText : state.translations.goToDashboard }}

      <mat-icon>navigate_next</mat-icon>

    </a>

  </div>
</zef-dialog>
